import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { COMPARE_PRICE, PRICE } from '../data/content';
const recap = ['6 dílů', '5 bonusů', '240 stran', '4–15 let'];
const reassurances = ['Okamžitě ke stažení', 'PDF k tisku', '7denní záruka spokojenosti'];
export function FinalCta() {
  return <section className="relative w-full overflow-hidden bg-seyes px-8 py-24 sm:px-14 sm:py-32" data-id="element-114" data-mp="15ckg2l9o5u77">
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-4 w-px bg-red-300 sm:left-8 lg:left-12" data-id="element-115" data-mp="1jbtx1n5p8sc8" />
      <div className="relative mx-auto max-w-3xl text-center" data-id="element-116" data-mp="1ebxt1nx050wo">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-117" data-mp="1t1wsdu0amidq">
          Vaše tréninky juda můžou být <em className="text-red-700" data-id="element-118" data-mp="1o5y5kaum58ff">hotové už dnes.</em>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-slate-900/75" data-id="element-119" data-mp="224eabw8x0oux">
          Místo hledání cvičení, sepisování každého tréninku a nedělních večerů nad plánováním
          máte přehledný tréninkový balíček na celou sezónu. Víc času na to,
          na čem opravdu záleží:
        </p>
        <p className="mt-6 font-serif text-2xl italic leading-snug text-slate-900 sm:text-3xl" data-id="element-120" data-mp="s57fd5g43ssb">
          Vaši judisté. Váš oddíl. Váš život mimo tatami.
        </p>

        <ul className="mt-10 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-medium text-slate-900/70" data-id="element-121" data-mp="123537ru27nke">
          {recap.map(item => <li key={item} data-id="element-122" data-mp="1646tvk9wurar">{item}</li>)}
        </ul>

        <p className="mt-8 font-serif text-6xl leading-none tracking-tight text-slate-900 sm:text-7xl" data-id="element-123" data-mp="1b31m1ctrps7j">
          <s className="mr-3 align-middle text-3xl text-slate-900/40 sm:text-4xl" data-id="element-124" data-mp="1ftqgn10qv5aw"><span className="sr-only" data-id="element-125" data-mp="1ktd3812gpxwd">Původně </span>{COMPARE_PRICE}</s>
          {PRICE}
        </p>
        <p className="mt-3 text-sm text-slate-900/70" data-id="element-126" data-mp="1psfxcqgwmjpk">Jednorázová platba – žádné předplatné.</p>

        <div className="mt-8 flex justify-center" data-id="element-127" data-mp="1pqmrvei125j5">
          <CtaButton className="w-full sm:w-auto" data-id="element-128" data-mp="1tuuglbohjlhd" />
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-1.5 text-sm text-slate-900/70" data-id="element-129" data-mp="3qufdfoonxirm">
          {reassurances.map(item => <li key={item} className="flex items-center gap-2" data-id="element-130" data-mp="3lwvr01ht9zol">
              <CheckIcon className="h-4 w-4 text-red-700" aria-hidden="true" data-id="element-131" data-mp="3hcunl3hpj42" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}